import React from 'react'

import { graphql, Link } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox'

import Image from 'gatsby-image'
import BackgroundImage from 'gatsby-image'

import { Grid } from '@material-ui/core'

import MainLayout from '../layouts/MainLayout/MainLayout'

import SEO from '../components/Seo/Seo'

import styles from './product-template.module.css'

const options = {
  buttons: {
    backgroundColor: 'white',
    iconColor: 'black',
  },
}

export default ({ data }) => {
  return (
    <MainLayout>
      <SEO title={data.contentfulProducts.title} />
      <Grid
        container
        className="bgWhite extraPaddingBottom"
        direction="column"
        alignItems="center"
      >
        <Grid item xs={12} md={10} lg={8}>
          <div className="navClear"></div>
          <h3>{data.contentfulProducts.title}</h3>
          <section className={styles.productListing}>
            <div className={styles.imagesContainer}>
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <div className={styles.productMainImage}>
                    <BackgroundImage
                      fluid={data.contentfulProducts.mainImage.fluid}
                      alt={data.contentfulProducts.mainImage.title}
                    />
                  </div>
                  <div className={styles.productAltImages}>
                    {data.contentfulProducts.alternativeImages.map(img => {
                      return (
                        <div className={styles.productAltImage}>
                          <Image fluid={img.fluid} alt={img.title} />
                        </div>
                      )
                    })}
                  </div>
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className={styles.productInfo}>
              <p className={styles.productPrice}>
                Prices starting at £{data.contentfulProducts.price}
              </p>
              {data.contentfulProducts.category === 'pods' ? (
                <>
                  <h3>Optional Extras</h3>
                  {data.allContentfulExtras.nodes.map(extra => {
                    return (
                      <>
                        <div className={styles.extraGroup}>
                          <p className={styles.extraTitle}>
                            {extra.extrasTitle} £{extra.extrasPrice}
                          </p>
                        </div>
                        <div className={styles.extradescription}>
                          {documentToReactComponents(
                            extra.extrasDescription.json
                          )}
                        </div>
                      </>
                    )
                  })}
                </>
              ) : null}
            </div>
          </section>
          <section>
            <h3>Specifications</h3>
            {documentToReactComponents(
              data.contentfulProducts.productDescription.json
            )}
          </section>
          <section className={styles.termsSection}>
            <h3>Terms & Conditions</h3>
            <br />
            <Link className={styles.termsLink} to="/terms">
              <p>Please click here to read our full terms & conditions page.</p>
            </Link>
          </section>
        </Grid>
      </Grid>
    </MainLayout>
  )
}

export const getProduct = graphql`
  query getProduct($slug: String) {
    contentfulProducts(productSlug: { eq: $slug }) {
      title
      price
      category
      productDescription {
        json
      }
      mainImage {
        title
        fluid {
          ...GatsbyContentfulFluid
        }
      }
      alternativeImages {
        title
        fluid {
          ...GatsbyContentfulFluid
        }
      }
    }
    allContentfulExtras {
      nodes {
        id
        extrasPrice
        extrasTitle
        extrasDescription {
          json
        }
      }
    }
  }
`
